export const PollDivCode = {
	SKE: 'SK에너지',
	GSC: 'GS칼텍스',
	HDO: '현대오일뱅크',
	SOL: 'S-OIL',
	RTE: '자영알뜰',
	RTX: '고속도로알뜰',
	NHO: '농협알뜰',
	ETC: '자가상표',
	E1G: 'E1',
	SKG: 'SK가스',
} as const;

export const LpgYn = {
	N: '주유소',
	Y: '자동차충전소',
	C: '주유소/충전소 겸업',
} as const;

export const ProductCodeMap = {
	휘발유: 'B027',
	경유: 'D047',
	고급휘발유: 'B034',
	LPG: 'C004',
	전기: 'K015',
} as const;

export type OilPrice = {
	PRODCD: (typeof ProductCodeMap)[keyof typeof ProductCodeMap];
	PRICE: number;
	TRADE_DT: string;
	TRADE_TM: string;
};

type OpinetResponse<T> = {
	RESULT: {
		OIL: T;
	};
};

type GasStationDetail = {
	UNI_ID: string;
	POLL_DIV_CD: keyof typeof PollDivCode;
	GPOLL_DIV_CD: keyof typeof PollDivCode;
	OS_NM: string;
	VAN_ADR: string;
	NEW_ADR: string;
	TEL: string;
	SIGUNCD: string;
	LPG_YN: keyof typeof LpgYn;
	MAINT_YN: 'Y' | 'N';
	CAR_WASH_YN: 'Y' | 'N';
	KPETRO_YN: 'Y' | 'N';
	CVS_YN: 'Y' | 'N';
	GIS_X_COOR: number;
	GIS_Y_COOR: number;
	OIL_PRICE: OilPrice[];
};

export type OpinetStationDetailResponse = OpinetResponse<GasStationDetail[]>;

export type SidoPriceItem = { prodcd: string; price: number; off: number };

export type RegionPriceResponse = { sido: string; prices: SidoPriceItem[] };

export type GasStationAround = {
	RESULT: {
		OIL: (Pick<
			GasStationDetail,
			'UNI_ID' | 'POLL_DIV_CD' | 'OS_NM' | 'GIS_X_COOR' | 'GIS_Y_COOR'
		> & {
			PRICE: number;
			DISTANCE: number;
		})[];
	};
};
